import {
  FAV_SAVE_STARTED,
  FAV_SAVE_INIT,
  ADD_ITEM_TO_FAVOURITES,
  UPDATE_MEMBER_FAVOURITE_LIST,
  HIDE_FAVOURITE_MODAL,
  FAV_SAVE_COMPLETE,
  FAV_INIT_MEMBER,
} from './actionTypes';
import { createAction } from '../utils/createAction';

export const displayFavoriteModal = createAction(FAV_SAVE_STARTED);
export const initAddToFavourites = createAction(FAV_SAVE_INIT);
export const saveToFavourites = createAction(ADD_ITEM_TO_FAVOURITES);
export const hideFavouritesModal = createAction(HIDE_FAVOURITE_MODAL);
export const completeSaveToFavourites = createAction(FAV_SAVE_COMPLETE);
export const initMemberData = createAction(FAV_INIT_MEMBER);
export const updateMemberFavouriteList = ({ listId, listName }) => ({
  type: UPDATE_MEMBER_FAVOURITE_LIST,
  listId,
  listName,
});
